import React, { useRef } from "react";
import BookItem from "./BookItem";

function Carousel(props) {
  const ref = useRef(null);

  const scroll = (scrollOffset) => {
    if (ref.current) {
      ref.current.scrollLeft += scrollOffset;
    }
  };

  return (
    <React.Fragment>
      <section className="container">
      <div className="row">
        <div className="col-1 navigation">
          <button onClick={() => scroll(-100)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 54 128"
              height="24"
              width="11"
            >
              <path d="M1 61l45-45 7 7-38 38 38 38-7 7z" />
            </svg>
          </button>
        </div>
        <div className="col-10">
          <div id="carousel" ref={ref}>
            {props.array.map((element, index) => (
              <div className="item" key={index}>
                <BookItem key={index} id={index} bookDetails={element} />
              </div>
            ))}
          </div>
        </div>
        <div className="col-1 navigation">
          <button onClick={() => scroll(100)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 54 128"
              height="24"
              width="11"
            >
              <path d="M1 99l38-38L1 23l7-7 45 45-45 45z" />
            </svg>
          </button>
        </div>
      </div>
      </section>
    </React.Fragment>
  );
}

export default Carousel;